import React from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router';
import { Page } from '../modules/roles/models/role-model'

type Props = {
  activePages: Page[]
}

const ActivePageBasedRedirect = ({ activePages = [] }: Props) => {
  const { pathname } = useLocation();

  if (pathname === '/') {
    return <Redirect to='/portal/draft-invoices' />;
  }

  // Let the next fallback route handle unknown paths (e.g., /error/404)
  if (!pathname) {
    return null;
  }

  return null;
};

export default ActivePageBasedRedirect;
